import styled from 'styled-components'

export const Box = styled.div`
    ${(props) => props.theme.boxShadow.level2};
    border-radius: 20px;
    background-color: ${(props) => props.theme.color.white};
`

export const Header = styled.div`
    padding: 30px;
    border-bottom: 1px solid ${(props) => props.theme.color.g300};
`

export const Title = styled.h3`
    ${(props) => props.theme.typo.bodyL};
    ${(props) => props.theme.fontWeight.medium};
    color: ${(props) => props.theme.color.g600};

    @media ${(props) => props.theme.query.min.tablet} {
        ${(props) => props.theme.typo.displayM};
    }
`

export const Body = styled.div`
    padding: 20px;

    @media ${(props) => props.theme.query.min.tablet} {
        padding: 30px;
    }
`
